webpackJsonp([238],{

/***/ 1297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserTrainingCourseTable_vue__ = __webpack_require__(3056);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa2cb7f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserTrainingCourseTable_vue__ = __webpack_require__(5669);
function injectStyle (ssrContext) {
  __webpack_require__(5667)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fa2cb7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserTrainingCourseTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fa2cb7f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserTrainingCourseTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* unused harmony export trimParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = removeEmptyParams;
/* harmony export (immutable) */ __webpack_exports__["d"] = setParams;
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* harmony export (immutable) */ __webpack_exports__["a"] = conveSomeDataType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSeachParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query);
        // 设置搜索参数
        vm.setSearchParams(queryParams);
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSeachParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSeachParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      params[key] = newParams[key];
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1505:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return consts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return opts; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getOptionLabel;
/* harmony export (immutable) */ __webpack_exports__["d"] = getCourseStatusLabel;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCourseStatusType;
/* harmony export (immutable) */ __webpack_exports__["c"] = getCourseStatusActions;
/* harmony export (immutable) */ __webpack_exports__["h"] = isCourseRelationEditLocked;
/* harmony export (immutable) */ __webpack_exports__["a"] = buildCourseKnowledgeQueryParams;
/* unused harmony export COURSE_UPLOAD_TYPE_CONFIGS */
/* unused harmony export getFileExtension */
/* unused harmony export getCourseContentTypeByFile */
/* harmony export (immutable) */ __webpack_exports__["f"] = getCourseUploadConfig;
/* harmony export (immutable) */ __webpack_exports__["j"] = validateCourseUploadFile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);




var _COURSE_UPLOAD_TYPE_C;

var consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2
  // CONTENT_TYPE_DOCUMENT: 3,
};

var opts = {
  contentTypeMaps: [{ value: consts.CONTENT_TYPE_IMAGE, label: '图片' }, { value: consts.CONTENT_TYPE_VIDEO, label: '视频' }],
  targetUserMaps: [{ value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false }, { value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true }],
  isCommonMaps: [{ value: consts.IS_COMMON_DEDICATED, label: '专用' }, { value: consts.IS_COMMON_SHARED, label: '通用' }],
  statusMaps: [{ value: consts.STATUS_NEW, label: '新创建' }, { value: consts.STATUS_ONLINE, label: '已上架' }, { value: consts.STATUS_OFFLINE, label: '已下架' }, { value: consts.STATUS_BANNED, label: '已作废' }]
};

function getOptionLabel(options, value) {
  var item = options.find(function (option) {
    return Number(option.value) === Number(value);
  });
  return item ? item.label : '';
}

function getCourseStatusLabel(status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态';
}

function getCourseStatusType(status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success';
    case consts.STATUS_OFFLINE:
      return 'warning';
    case consts.STATUS_BANNED:
      return 'danger';
    default:
      return 'info';
  }
}

function getCourseStatusActions(status) {
  var isSuperAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }];
    case consts.STATUS_ONLINE:
      return [{ name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功' }];
    case consts.STATUS_OFFLINE:
      return [{ name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功' }].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(isSuperAdmin ? [{ name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功' }] : []));
    case consts.STATUS_BANNED:
      return isSuperAdmin ? [{ name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功' }] : [];
    default:
      return [];
  }
}

function isCourseRelationEditLocked(id, status) {
  return Number(id) > 0 && [consts.STATUS_ONLINE, consts.STATUS_OFFLINE].includes(Number(status));
}

function buildCourseKnowledgeQueryParams(_ref) {
  var isCommon = _ref.is_common,
      customerid = _ref.customerid;

  var params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon)
  };

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid];
  }

  return params;
}

var COURSE_UPLOAD_TYPE_CONFIGS = (_COURSE_UPLOAD_TYPE_C = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_IMAGE, {
  accept: ['image/jpeg', 'image/png', 'image/jpg'],
  extensions: ['jpg', 'jpeg', 'png'],
  maxFiles: 0,
  maxSizeMB: 20,
  tip: '支持 JPG、PNG，可上传多张，单个最大 20MB'
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_COURSE_UPLOAD_TYPE_C, consts.CONTENT_TYPE_VIDEO, {
  accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
  extensions: ['mp4', 'avi', 'mov'],
  maxFiles: 1,
  maxSizeMB: 1024,
  tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB'
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}), _COURSE_UPLOAD_TYPE_C);

function getFileExtension(name) {
  var parts = String(name || '').split('.');
  return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

function getCourseContentTypeByFile(file) {
  var type = String(file && file.type || '');
  var ext = getFileExtension(file && file.name);

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE;
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO;
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0;
}

function getCourseUploadConfig(contentType) {
  if (!contentType) {
    var configs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(COURSE_UPLOAD_TYPE_CONFIGS).map(function (type) {
      return COURSE_UPLOAD_TYPE_CONFIGS[type];
    });
    return {
      accept: configs.reduce(function (result, item) {
        return result.concat(item.accept);
      }, []),
      extensions: configs.reduce(function (result, item) {
        return result.concat(item.extensions);
      }, []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(function (item) {
        return item.maxSizeMB;
      })),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个'
    };
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE];
}

function validateCourseUploadFile(file) {
  var currentFiles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var currentContentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var contentType = getCourseContentTypeByFile(file);
  if (!contentType) {
    return {
      valid: false,
      contentType: contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false
    };
  }

  var config = getCourseUploadConfig(contentType);
  var currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0;
  var maxSize = config.maxSizeMB * 1024 * 1024;
  var ext = getFileExtension(file && file.name);

  if (!file || !config.accept.includes(file.type) && !config.extensions.includes(ext)) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType: contentType,
      message: config.tip,
      replaceAll: false
    };
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType: contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(function (item) {
        return Number(item.content_type || item.type || currentContentType) !== contentType;
      })
    };
  }

  return {
    valid: true,
    contentType: contentType,
    message: '',
    replaceAll: currentFiles.some(function (item) {
      return Number(item.content_type || item.type || currentContentType) !== contentType;
    })
  };
}

/***/ }),

/***/ 1515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getExel */
/* unused harmony export getExelByPost */
/* harmony export (immutable) */ __webpack_exports__["a"] = NumberArray;
/* unused harmony export StringArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var base = window._env_.VUE_APP_HOST;
function getExel(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'GET',
      url: base + url,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer',
      params: params
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}
function getExelByPost(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var data = {
      method: 'post',
      url: base + url,
      data: params,
      headers: {
        Authorization: localStorage.getItem('tokenType') + ' ' + localStorage.getItem('token'),
        'Authorization-Guard': localStorage.getItem('guard')
      },
      responseType: 'arraybuffer'
    };
    resolve(__WEBPACK_IMPORTED_MODULE_1_axios___default()(data));
  });
}

// 将字符串数组转换为数字数组
function NumberArray(value) {
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return Number(item);
  });
}

function StringArray(value) {
  // 如果 value 不是数组，则将其转换成数组
  var valueArray = Array.isArray(value) ? value : [value];
  return valueArray.map(function (item) {
    return String(item);
  });
}

/***/ }),

/***/ 1518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      instructionGroups: []
    };
  },

  methods: {
    loadGroups: function loadGroups() {
      var _this = this;

      request.page('queryTrainingInstructionGroupAll').then(function (_ref) {
        var data = _ref.data;

        _this.instructionGroups = data.map(function (it) {
          return { value: it.id, label: it.name };
        });
      });
    },
    deleteInstructionGroup: function deleteInstructionGroup(item) {
      var _this2 = this;

      this.$confirm('\u786E\u8BA4\u5220\u9664\u5206\u7EC4\u300C' + item.label + '\u300D\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        return request.common('deleteTrainingInstructionGroup', item.value);
      }).then(function () {
        _this2.$message.success('删除成功');
        _this2.onInstructionGroupDeleted(item);
        _this2.loadGroups();
      }).catch(function () {});
    },
    onInstructionGroupDeleted: function onInstructionGroupDeleted(item) {
      if (this.form && this.form.instruction_group_name === item.label) {
        this.form.instruction_group_name = null;
      }
      if (this.search && Number(this.search.instruction_group_id) === Number(item.value)) {
        this.search.instruction_group_id = null;
      }
    },
    getOptionLabel: function getOptionLabel(optType, val) {
      var type = this.options[optType].find(function (one) {
        return one.value === val;
      });
      return type ? type.label : '';
    }
  }
});

/***/ }),

/***/ 1613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSuperAdminUser;
function isSuperAdminUser(user) {
  return Number(user && user.usertype) === 1;
}

/***/ }),

/***/ 3056:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_mixins_table__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_training_training_mixins__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_training_training_user__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_common__ = __webpack_require__(1515);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__core_mixins_table__["b" /* default */], __WEBPACK_IMPORTED_MODULE_2__views_training_training_mixins__["a" /* default */]],
  data: function data() {
    return {
      consts: __WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["b" /* consts */],
      courseOptions: __WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["i" /* opts */],
      search: {
        title: null,
        content_type: null,
        target_usertype: null,
        status: [],
        is_common: null,
        training_knowledge_id: [],
        customerid: [],
        creator_id: [],
        created_at: []
      },
      searchFieldType: {
        content_type: Number,
        target_usertype: Number,
        status: __WEBPACK_IMPORTED_MODULE_5__utils_common__["a" /* NumberArray */],
        is_common: Number,
        training_knowledge_id: __WEBPACK_IMPORTED_MODULE_5__utils_common__["a" /* NumberArray */],
        customerid: Array,
        creator_id: __WEBPACK_IMPORTED_MODULE_5__utils_common__["a" /* NumberArray */],
        created_at: Array
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    loginUser: function loginUser(state) {
      return state.login.user || {};
    }
  }), {
    isSuperAdmin: function isSuperAdmin() {
      return Object(__WEBPACK_IMPORTED_MODULE_3__views_training_training_user__["a" /* isSuperAdminUser */])(this.loginUser);
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, request.map(['queryTrainingKnowledge', 'getTrainingKnowledge', 'getCustomerTable', 'getCustomerDetail', 'getBasicPlatformUsersIndex', 'getPlatformUsersDetail']), {
    getTableData: function getTableData(params) {
      return request.page('queryUserTrainingCourse', params);
    },
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
      this.onSearch();
    },
    getContentTypeLabel: function getContentTypeLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["g" /* getOptionLabel */])(this.courseOptions.contentTypeMaps, value) || '-';
    },
    getTargetUserLabel: function getTargetUserLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["g" /* getOptionLabel */])(this.courseOptions.targetUserMaps, value) || '-';
    },
    getIsCommonLabel: function getIsCommonLabel(value) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["g" /* getOptionLabel */])(this.courseOptions.isCommonMaps, value) || '-';
    },

    getCourseStatusLabel: __WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["d" /* getCourseStatusLabel */],
    getStatusTagClass: function getStatusTagClass(status) {
      return 'course-tag--' + Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["e" /* getCourseStatusType */])(status);
    },
    getTagClass: function getTagClass(type, value) {
      if (type === 'content') {
        if (Number(value) === this.consts.CONTENT_TYPE_IMAGE) {
          return 'course-tag--primary';
        }
        if (Number(value) === this.consts.CONTENT_TYPE_VIDEO) {
          return 'course-tag--success';
        }
        return 'course-tag--warning';
      }
      if (type === 'user') {
        return Number(value) === this.consts.TARGETUSER_TYPE_USER ? 'course-tag--primary' : 'course-tag--warning';
      }
      if (type === 'common') {
        return Number(value) === this.consts.IS_COMMON_SHARED ? 'course-tag--success' : 'course-tag--default';
      }
      return 'course-tag--default';
    },
    getActionConfig: function getActionConfig(status, name) {
      return Object(__WEBPACK_IMPORTED_MODULE_4__views_training_training_course_constants__["c" /* getCourseStatusActions */])(status, this.isSuperAdmin).find(function (action) {
        return action.name === name;
      });
    },
    handleCourseAction: function handleCourseAction(row, name) {
      var _this = this;

      var action = this.getActionConfig(row.status, name);
      if (!action) {
        return;
      }
      this.$confirm('\u786E\u5B9A\u8981' + action.label + '\u6559\u7A0B\u3010' + row.title + '\u3011\u5417\uFF1F', '提示', { type: 'warning' }).then(function () {
        request.common(action.apiName, row.id).then(function () {
          _this.$message.success(action.successText);
          _this.onRefresh();
        });
      });
    }
  })
});

/***/ }),

/***/ 5667:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5668);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("6be6b1df", content, true, {});

/***/ }),

/***/ 5668:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".course-title[data-v-1fa2cb7f],.knowledge-name[data-v-1fa2cb7f]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d}.knowledge-name__icon[data-v-1fa2cb7f]{margin-right:8px;color:#f5a623;font-size:14px}.course-tag[data-v-1fa2cb7f]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap}.course-tag--primary[data-v-1fa2cb7f]{color:#409eff;background-color:#ecf5ff}.course-tag--success[data-v-1fa2cb7f]{color:#00a854;background-color:#d9f7e7}.course-tag--warning[data-v-1fa2cb7f]{color:#e6a23c;background-color:#fdf6ec}.course-tag--danger[data-v-1fa2cb7f]{color:#f56c6c;background-color:#fef0f0}.course-tag--default[data-v-1fa2cb7f],.course-tag--info[data-v-1fa2cb7f]{color:#1f2d3d;background-color:#f4f5f7}", "", {"version":3,"sources":["/workspace/src/views/training/pages/course/UserTrainingCourseTable.vue"],"names":[],"mappings":"AAGA,gEAAiC,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,iBAAiB,aAAa,CAC1M,AACD,uCAAuC,iBAAiB,cAAc,cAAc,CACnF,AACD,6BAA6B,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,YAAY,eAAe,mBAAmB,8BAA8B,sBAAsB,eAAe,iBAAiB,kBAAkB,CAC/Y,AACD,sCAAsC,cAAc,wBAAwB,CAC3E,AACD,sCAAsC,cAAc,wBAAwB,CAC3E,AACD,sCAAsC,cAAc,wBAAwB,CAC3E,AACD,qCAAqC,cAAc,wBAAwB,CAC1E,AACD,yEAAyE,cAAc,wBAAwB,CAC9G","file":"UserTrainingCourseTable.vue","sourcesContent":["\n.course-title[data-v-1fa2cb7f]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d\n}\n.knowledge-name[data-v-1fa2cb7f]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;line-height:20px;color:#1f2d3d\n}\n.knowledge-name__icon[data-v-1fa2cb7f]{margin-right:8px;color:#f5a623;font-size:14px\n}\n.course-tag[data-v-1fa2cb7f]{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:56px;height:22px;padding:0 12px;border-radius:11px;-webkit-box-sizing:border-box;box-sizing:border-box;font-size:12px;line-height:22px;white-space:nowrap\n}\n.course-tag--primary[data-v-1fa2cb7f]{color:#409EFF;background-color:#ecf5ff\n}\n.course-tag--success[data-v-1fa2cb7f]{color:#00a854;background-color:#d9f7e7\n}\n.course-tag--warning[data-v-1fa2cb7f]{color:#e6a23c;background-color:#fdf6ec\n}\n.course-tag--danger[data-v-1fa2cb7f]{color:#f56c6c;background-color:#fef0f0\n}\n.course-tag--info[data-v-1fa2cb7f],.course-tag--default[data-v-1fa2cb7f]{color:#1f2d3d;background-color:#f4f5f7\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("考试培训管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"108px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"教程标题","prop":"title"}},[_c('el-input',{attrs:{"clearable":"","placeholder":"请输入教程标题搜索"},model:{value:(_vm.search.title),callback:function ($$v) {_vm.$set(_vm.search, "title", $$v)},expression:"search.title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"教程类型","prop":"content_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择教程类型"},model:{value:(_vm.search.content_type),callback:function ($$v) {_vm.$set(_vm.search, "content_type", $$v)},expression:"search.content_type"}},_vm._l((_vm.courseOptions.contentTypeMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户类型","prop":"target_usertype"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择用户类型"},model:{value:(_vm.search.target_usertype),callback:function ($$v) {_vm.$set(_vm.search, "target_usertype", $$v)},expression:"search.target_usertype"}},_vm._l((_vm.courseOptions.targetUserMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","placeholder":"请选择状态"},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.courseOptions.statusMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"是否通用","prop":"is_common"}},[_c('el-select',{staticClass:"width-max",attrs:{"clearable":"","placeholder":"请选择是否通用"},model:{value:(_vm.search.is_common),callback:function ($$v) {_vm.$set(_vm.search, "is_common", $$v)},expression:"search.is_common"}},_vm._l((_vm.courseOptions.isCommonMaps),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属知识库","prop":"training_knowledge_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入知识库名称搜索","query-request":_vm.queryTrainingKnowledge,"find-request":_vm.getTrainingKnowledge},model:{value:(_vm.search.training_knowledge_id),callback:function ($$v) {_vm.$set(_vm.search, "training_knowledge_id", $$v)},expression:"search.training_knowledge_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"所属客户","prop":"customerid"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入客户关键字","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail},model:{value:(_vm.search.customerid),callback:function ($$v) {_vm.$set(_vm.search, "customerid", $$v)},expression:"search.customerid"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建人","prop":"creator_id"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","multiple":"","id-key":"id","keyword-key":"name","label-key":"name","value-key":"id","placeholder":"请输入创建人","query-request":_vm.getBasicPlatformUsersIndex,"find-request":_vm.getPlatformUsersDetail},model:{value:(_vm.search.creator_id),callback:function ($$v) {_vm.$set(_vm.search, "creator_id", $$v)},expression:"search.creator_id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"创建时间","prop":"created_at"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"至","start-placeholder":"开始日期","end-placeholder":"结束日期","align":"right","default-time":['00:00:00', '23:59:59'],"value-format":"yyyy-MM-dd HH:mm:ss"},model:{value:(_vm.search.created_at),callback:function ($$v) {_vm.$set(_vm.search, "created_at", $$v)},expression:"search.created_at"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索")]),_vm._v(" "),_c('el-button',{on:{"click":function($event){return _vm.resetSearch()}}},[_vm._v("重置")])],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/training/user-course/create"}},[_c('el-button',{attrs:{"type":"primary","size":"small"}},[_vm._v("创建教程")])],1),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":""}},[_c('el-table-column',{attrs:{"prop":"id","label":"ID","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"title","label":"教程标题","min-width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"course-title"},[_vm._v(_vm._s(scope.row.title))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"content_type","label":"教程类型","width":"110"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"course-tag",class:_vm.getTagClass('content', scope.row.content_type)},[_vm._v("\n            "+_vm._s(_vm.getContentTypeLabel(scope.row.content_type))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"target_usertype","label":"用户类型","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"course-tag",class:_vm.getTagClass('user', scope.row.target_usertype)},[_vm._v("\n            "+_vm._s(_vm.getTargetUserLabel(scope.row.target_usertype))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"is_common","label":"是否通用","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"course-tag",class:_vm.getTagClass('common', scope.row.is_common)},[_vm._v("\n            "+_vm._s(_vm.getIsCommonLabel(scope.row.is_common))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"knowledge_name","label":"所属知识库","min-width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"knowledge-name"},[_c('i',{staticClass:"el-icon-folder knowledge-name__icon"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(scope.row.knowledge_name))])])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"customer_name","label":"所属客户","min-width":"140"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.customer_name || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"created_at","label":"创建时间","width":"170"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_name","label":"创建人","min-width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(scope.row.user_name || '-'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"状态","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{staticClass:"course-tag",class:_vm.getStatusTagClass(scope.row.status)},[_vm._v("\n            "+_vm._s(_vm.getCourseStatusLabel(scope.row.status))+"\n          ")])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"210"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('router-link',{attrs:{"to":("/training/user-course/update/" + (scope.row.id))}},[_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""}},[_vm._v("编辑")])],1),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_NEW)?_c('el-button',{attrs:{"type":"success","size":"mini","plain":""},on:{"click":function($event){return _vm.handleCourseAction(scope.row, 'online')}}},[_vm._v("上架")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_ONLINE)?_c('el-button',{attrs:{"type":"warning","size":"mini","plain":""},on:{"click":function($event){return _vm.handleCourseAction(scope.row, 'offline')}}},[_vm._v("下架")]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin && Number(scope.row.status) === _vm.consts.STATUS_OFFLINE)?_c('el-button',{attrs:{"type":"danger","size":"mini","plain":""},on:{"click":function($event){return _vm.handleCourseAction(scope.row, 'ban')}}},[_vm._v("作废")]):_vm._e(),_vm._v(" "),(Number(scope.row.status) === _vm.consts.STATUS_OFFLINE)?_c('el-button',{attrs:{"type":"success","size":"mini","plain":""},on:{"click":function($event){return _vm.handleCourseAction(scope.row, 'online')}}},[_vm._v("上架")]):_vm._e(),_vm._v(" "),(_vm.isSuperAdmin && Number(scope.row.status) === _vm.consts.STATUS_BANNED)?_c('el-button',{attrs:{"type":"primary","size":"mini","plain":""},on:{"click":function($event){return _vm.handleCourseAction(scope.row, 'active')}}},[_vm._v("激活")]):_vm._e()]}}])})],1),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/user-training-course.4482aab42548fe0596f5.js